import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { authService } from '../shared/services/authService';
import { recordPageView } from '../shared/services/navStatsService';

/**
 * Fire-and-forget page visit tracking for authenticated /app routes.
 * Used later to decide top-nav grouping from real usage, by role.
 */
export function usePageNavTracker(): void {
  const location = useLocation();
  const lastSentRef = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (!path.startsWith('/app')) return;
    if (path === lastSentRef.current) return;
    if (!authService.isAuthenticated()) return;

    const prev = lastSentRef.current;
    lastSentRef.current = path;
    void recordPageView(path, prev || undefined);
  }, [location.pathname]);
}
